export default "__VITE_ASSET__D04slq2J__"